'use client'

import { C500 } from 'ui'

// pages/500.tsx: rendering errors below the root layout
export default function Error() {
  return <C500 />
}
